export default __webpack_public_path__ + "static/media/bg-modal.2986bdbf.png";